function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".monitoring_svg__cls-1{fill:#f5f8fc}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "monitoring_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "monitoring_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "monitoring_svg__cls-1",
  d: "M23.11 0H4.68A4.43 4.43 0 000 4.68V17a4.43 4.43 0 004.68 4.7h6.27v1.12h-.66a1.09 1.09 0 100 2.18h7.4a1.09 1.09 0 100-2.18h-.95V21.7h6.37a4.42 4.42 0 004.68-4.7V4.68A4.43 4.43 0 0023.11 0zm-8.55 22.82h-1.42V21.7h1.42zm11-5.78a2.24 2.24 0 01-2.48 2.48H4.68A2.25 2.25 0 012.18 17v-.26h23.41zm0-2.44H2.18V4.68a2.26 2.26 0 012.5-2.5h18.43a2.25 2.25 0 012.48 2.5z"
}), React.createElement("path", {
  className: "monitoring_svg__cls-1",
  d: "M23.37 4.68l-4.61 6.08a1.12 1.12 0 01-.87.43h-.05a1 1 0 01-.81-.42l-1.54-1.93-2.84 3a1.08 1.08 0 01-.91.33 1.14 1.14 0 01-.83-.53L9.3 8.84l-3 4.8a1.11 1.11 0 01-.92.51 1.15 1.15 0 01-.64-.15 1.11 1.11 0 01-.49-.68 1.21 1.21 0 01.14-.83l4-6.31a1 1 0 01.89-.51h.05a1.16 1.16 0 01.92.54l1.79 3.06 2.71-2.82a1 1 0 01.84-.34 1.11 1.11 0 01.8.41l1.45 1.83 3.77-5a1.09 1.09 0 011.73 1.31z"
})));

var SvgMonitoring = function SvgMonitoring(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 27.79 25"
  }, props), _ref, _ref2);
};

export default SvgMonitoring;